import {deleteTwoFactorConfig, getTwoFactorConfig, useClientAccountOverview} from "@twigsby/client-data";
import {updateTwoFactorConfig} from "@twigsby/client-data/lib/Endpoints/UserSettingsEndpoints";
import {
    Button,
    ColourSolid,
    FlexAlign,
    FlexGap,
    FlexJustify, Modal, ModalType,
    StackHorizontal,
    StackVertical, Trans,
    useTranslation
} from "@twigsby/frontend-framework";
import React, {useEffect, useState} from "react";
import {useSite} from "../../../Providers/SiteInterfaceProvider";

type TwoFactorEntryType = {
    isConfigured: boolean;
    twoStepAuthenticationTypeId: number;
    twoStepAuthenticationTypeName: string;
}

const TwoFactor = () => {
    const { t } = useTranslation();
    const { currentLocale, updatePageMeta } = useSite();

    const [authTypes, setAuthTypes] = useState<Array<TwoFactorEntryType>>([]);
    const [recoveryCodes, setRecoveryCodes] = useState<Array<string>>([]);

    const GetAuthConfigs = async () => {
        await getTwoFactorConfig().then((r:any) => {
            console.log('getTwoFactorConfig', r);
            setAuthTypes(r.twoFactorAuthenticationConfigurations)
        });
    }

    const UpdateAuthConfigs = async (value: Array<number>) => {
        await updateTwoFactorConfig(value).then((r: any) => {
            console.log('updateTwoFactorConfig', r);
            if(r) {
                setRecoveryCodes(r.recoveryCodes);
            }
        });
    }

    const RemoveAuthType = async () => {
        await deleteTwoFactorConfig().then(() => setAuthTypes([]));
    }

    useEffect(() => {
        updatePageMeta({
            title: t('settings.loginHistory.title')
        });
    }, [currentLocale]);

    useEffect(() => {
        GetAuthConfigs();
    }, []);

    return (
        <StackVertical gap={FlexGap.Small}>
            <StackHorizontal align={FlexAlign.Center} justify={FlexJustify.Between} extraClass={'mb-xs'}>
                <h2 className={'mb-0'}>{t('settings.twoFactorAuth.title')}</h2>
            </StackHorizontal>
            <p>{t('settings.twoFactorAuth.description')}</p>

            <Button onClick={() => UpdateAuthConfigs([1])} title={'Enable'} colour={ColourSolid.Secondary} />

            <div>
                {authTypes.map((item: any) =>
                    <TwoFactorEntry
                        {...item}
                        removeCallback={() => RemoveAuthType()}
                    />
                )}
            </div>

            <TwoFactorConfirmationModal
                isOpen={recoveryCodes.length > 0}
                closeCallback={() => setRecoveryCodes([])}
                recoveryCodes={recoveryCodes}
            />
        </StackVertical>
    )
}

const TwoFactorEntry = (props: TwoFactorEntryType) => {
    const { t } = useTranslation();
    const { data} = useClientAccountOverview();

    return (
        <StackHorizontal gap={FlexGap.Small}>
            <Button onClick={() => deleteTwoFactorConfig()} title={'Disable'} colour={ColourSolid.Success} />
            <StackVertical gap={FlexGap.ExtraSmall}>
                <h6 className={'m-0'}>{t(`settings.twoFactorAuth.authTypes.${props.twoStepAuthenticationTypeId.toString()}.title`)}</h6>
                <Trans
                    defaults={`settings.twoFactorAuth.authTypes.${props.twoStepAuthenticationTypeId.toString()}.description`}
                    values={{ emailAddress: data?.username}}
                    components={{ bold: <strong /> }}
                />
            </StackVertical>
        </StackHorizontal>
    )
}

interface TwoFactorConfirmationModalType extends ModalType {
    recoveryCodes: Array<string>;
}

const TwoFactorConfirmationModal = (props: TwoFactorConfirmationModalType) => {
    const { t } = useTranslation();

    return (
        <Modal title={t(`settings.twoFactorAuth.authTypes.1.confirmation.title`)} isOpen={props.isOpen} closeCallback={props.closeCallback}>
            <div className={'recovery-codes'}>
                <p>{t(`settings.twoFactorAuth.authTypes.1.confirmation.description`)}</p>
                <p>{t(`settings.twoFactorAuth.authTypes.1.confirmation.warning`)}</p>
                <div className={'recovery-codes'}>
                    {props.recoveryCodes.map((code) => <span>{code}</span>)}
                </div>
            </div>
            <Button title={'Copy'} />
        </Modal>
    )
}

export default TwoFactor
